import {RailsPdtConstants} from './RailsPdtConstants';
import RailsPdtThankYouEvent from '../PdtModel/PdtEvents/RailsPdtThankYouEvent';
import {pushPdtData} from '../PdtAnalytics';

export default class RailsPdtThankYouHelper {
  static trackPageLoad(data) {
    try {
      const pdtData = data;
      pdtData.activityName = RailsPdtConstants.BaseEventAction.LOAD_PAGE;
      const pdtObject = new RailsPdtThankYouEvent(pdtData).trackThankYouEvent();
      pushPdtData(pdtObject);
    } catch (e) {
      // ignore
    }
  }
}
